export default __webpack_public_path__ + "static/media/MH.3e58b87b.svg";